import React from "react";
import { useFormContext } from "react-hook-form";
import { CreateAdminFormFields } from "Shared/types/Admins";
import { AccessLevelFormSelect } from "Components/Shared/FormComponents/AccessLevelFormSelect/AccessLevelFormSelect";


const AccessLevelSelect = () => {
  const { errors, control } = useFormContext<CreateAdminFormFields>();

  return (
    <AccessLevelFormSelect
      control={control}
      showError={!!errors.permissions}
    />
  );
};

export default AccessLevelSelect;
